import { render } from "./account-startups-page.vue?vue&type=template&id=949ad390&ts=true"
import script from "./account-startups-page.vue?vue&type=script&lang=ts"
export * from "./account-startups-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__